import * as proHome from './PcModule/home'
import * as shop from './PcModule/shop'
import * as mine from './PcModule/mine'

export default Object.assign({}, proHome, shop, mine)